<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateRangeGround"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillrangeCalibrationForm="fillrangeCalibrationForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('samples.ranges')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillrangeCalibrationForm="fillrangeCalibrationForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.date') }}:</strong>
                        </h6>
                        {{ formatDate }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.type') }}:</strong>
                        </h6>
                        {{ rangeCalibrationForm.calibration_type }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('samples.ranges') }}:</strong>
                        </h6>
                        <br />
                        <ul
                          v-for="(fert, index) in rangeCalibrationForm.names"
                          :key="index"
                        >
                          <li>
                            {{ $t('samples.range_name') }}:
                            {{ rangeCalibrationForm.names[index] }}
                          </li>
                          <li>
                            {{ $t('common_words.limit_lower') }}:
                            {{ rangeCalibrationForm.lim_inf_operators[index] }}
                            {{ rangeCalibrationForm.lim_infs[index] }}
                          </li>
                          <li>
                            {{ $t('common_words.limit_upper') }}:
                            {{ rangeCalibrationForm.lim_sup_operators[index] }}
                            {{ rangeCalibrationForm.lim_sups[index] }}
                          </li>
                          <li>{{ $t('common_words.color') }}:</li>
                          <li
                            :style="{
                              backgroundColor:
                                rangeCalibrationForm.color[index],
                              color: rangeCalibrationForm.text_color[index],
                              fontWeight: 'bold',
                              padding: '5px 10px',
                              borderRadius: '5px',
                              textAlign: 'center',
                              width: '15%',
                            }"
                          >
                            {{ $t('common_words.text_color') }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import moment from 'moment';
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      rangeCalibrationForm: {},
      calibration_types: [],
    };
  },
  computed: {
    formatDate() {
      return moment(this.rangeCalibrationForm.date).format('YYYY-MM-DD');
    },
  },
  mixins: [mixinMasters, MixinPermissions, MixinMenu],
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {
        id: null,
        date: null,
        calibration_type_id: null,
        businesses_id: [],
      };
      this.$refs.secondStep.cleanStep();
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillrangeCalibrationForm(ref) {
      this.rangeCalibrationForm = Object.assign(
        {},
        this.rangeCalibrationForm,
        this.$refs[ref].model
      );

      if (ref == 'firstStep') {
        if (this.rangeCalibrationForm.calibration_type_id) {
          let indexToFind = this.$refs['firstStep'].calibration_types.findIndex(
            (n) => n.id == this.rangeCalibrationForm.calibration_type_id
          );
          this.rangeCalibrationForm.calibration_type =
            this.$refs['firstStep'].calibration_types[indexToFind].name;
        }
      }
    },

    storeUpdateRangeGround() {
      this.showHideLoading(true);
      this.rangeCalibrationForm.route = 'calibration/calibrationranges';

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.rangeCalibrationForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.rangeCalibrationForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/calibration/calibrationranges',
                'rangeCalibrationForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.rangeCalibrationForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/calibration/calibrationranges',
                'rangeCalibrationForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  created() {
    Axios.getMasters('calibration/calibrationtypes')
      .then((response) => {
        this.calibration_types = response.data.data;
      })
      .catch((error) => this.showMessageErrors(error));
  },

  mounted() {
    this.selectedItemOnMenu('calibration');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('calibration');
    sessionStorage.removeItem('editForm');
  },
};
</script>
